import React, { useEffect, useMemo } from "react";
import { useQuery } from "@apollo/client";
import { type PaginationInterpreter, usePaginationContext } from "../../common/state";
import { type GetCachedGroupListV2Query, getCachedGroupListV2 } from "../api/queries";
import { GroupListPaginationContext } from "../context/GroupListPaginationContext";
import { GroupsGridItemModel } from "../grid/model";
import type { GroupWithConnections } from "../../../gql-generated/types";

export const useLoadGroupsV2 = (preload: boolean = true) => {
    const paginationContext = usePaginationContext(GroupListPaginationContext as React.Context<PaginationInterpreter>);
    const { firstLoad } = paginationContext;
    const { data } = useQuery<GetCachedGroupListV2Query>(getCachedGroupListV2, {
        fetchPolicy: "cache-only",
    });

    useEffect(() => {
        if (preload) {
            firstLoad();
        }
    }, [firstLoad, preload]);

    const groups: GroupsGridItemModel[] = useMemo(
        () =>
            data?.getGroupListV2?.groupsWithConnections?.map((conn) =>
                GroupsGridItemModel.createFromGroupWithConnections(conn as GroupWithConnections),
            ) ?? [],
        [data],
    );

    return {
        groups,
        ...paginationContext,
    };
};
